export default __webpack_public_path__ + "static/media/not-dance.2e1a2274.png";